import { Helmet } from "react-helmet-async";

const SITE_URL = "https://artkoz.pl";
const SITE_NAME = "ArtKoz";
function Seo({
  title,
  description,
  canonical,
  ogImage = "/Images/Logo/LogoArtKoz.png"
}) {
  const fullTitle = `${title} | ${SITE_NAME}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE_URL}${canonical}`} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE_URL}${canonical}`} />
      <meta property="og:image" content={`${SITE_URL}${ogImage}`} />
      <meta property="og:locale" content="pl_PL" />
      <meta property="og:site_name" content="ArtKoz" />

      {/* Twitter Card */}
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE_URL}${ogImage}`} /> */}

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: SITE_NAME,
          description:
            "Tworzenie stron internetowych oraz szkolenia informatyczne dla osób prywatnych, firm i instytucji.",
          url: SITE_URL,
          telephone: "+48 734 959 867",
          email: "biuro.artkoz@gmail.com",

          areaServed: ["Okolice Lublina", "Polska"],

          serviceType: [
            "Tworzenie stron internetowych",
            "Projektowanie stron WWW",
            "Szkolenia informatyczne",
            "Kursy komputerowe"
          ]
        })}
      </script>
    </Helmet>
  );
}

export default Seo;
